//
import { OrderedMap, Record } from 'immutable';
import { DateTime } from 'luxon';

export interface Notification {
  id: string | undefined;
  severity?: 'error' | 'warning' | 'info' | 'success' | undefined;
  message?: string | undefined;
  snackbarContent?: any | undefined;
  snackbarContentProps?: any | undefined;
  // A `null` duration means never auto-hide, which is how MUI reads it; `undefined` falls back to
  // the renderer's default.
  autoHideDuration?: number | null | undefined;
  createdAt: string | undefined;
  anchorOrigin: { horizontal: string; vertical: string };
  anchorIndex?: number | undefined;
  height: number;
  onClose?: () => void;
}

// 1. Define a default object
const defaultNotification: Notification = {
  id: undefined,
  message: undefined,
  snackbarContent: undefined,
  snackbarContentProps: undefined,
  autoHideDuration: undefined,
  createdAt: undefined,
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
  anchorIndex: undefined,
  height: 70,
  severity: undefined,
  onClose: undefined,
};

// 2. Create a Record factory
const NotificationRecordFactory = Record<Notification>(defaultNotification);

// 3. Export a strongly typed class that extends the Record factory
export class NotificationRecord extends NotificationRecordFactory implements Notification {}

// 4. Create a new record instance
export const mkNotification = (notification: Partial<Notification> = {}): NotificationRecord => {
  return new NotificationRecord({
    createdAt: DateTime.local().toISO(),
    ...notification,
  });
};

export const mkNotificationsStore = Record({
  notifications: OrderedMap(),
});
